import React from 'react';

interface Props {
    className?: string;
}

export const PointsIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M20,5.1c0-0.6-0.4-1-1-1h-3.9c-0.5,0-0.7,0.6-0.4,0.9l1.5,1.5l-5,5L7.9,8c-0.4-0.4-1-0.4-1.4,0l-6.1,6.1
                c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l5.4-5.4l3.4,3.4c0.4,0.4,1,0.4,1.4,0l5.7-5.7l1.5,1.5C19.5,9.7,20,9.4,20,9L20,5.1z"
            />
        </svg>
    );
};
